import React, { createContext, useState, useEffect } from 'react';
import authService from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const normalizeUser = (rawUser) => {
    if (!rawUser || typeof rawUser !== 'object') return null;

    const roleValue =
      rawUser.role ??
      rawUser.Role ??
      rawUser?.user?.role ??
      rawUser?.user?.Role ??
      '';

    return {
      ...rawUser,
      role: String(roleValue).trim().toLowerCase(),
      username:
        rawUser.username ??
        rawUser.Username ??
        rawUser?.user?.username ??
        rawUser?.user?.Username ??
        '',
      referralCode:
        rawUser.referralCode ??
        rawUser.ReferralCode ??
        '',
      referralLink:
        rawUser.referralLink ??
        rawUser.ReferralLink ??
        '',
      referralCount:
        rawUser.referralCount ??
        rawUser.ReferralCount ??
        0,
      referralBonusEarned:
        rawUser.referralBonusEarned ??
        rawUser.ReferralBonusEarned ??
        0
    };
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authService.getProfile()
        .then(data => {
          setUser(normalizeUser(data));
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const data = await authService.login(username, password);
    const token = data?.token || data?.Token;
    if (token) {
      localStorage.setItem('token', token);
      const profile = await authService.getProfile();
      setUser(normalizeUser(profile));
    }
  };

  const register = async (firstName, lastName, phone, username, password, role, referredByCode, deviceFingerprint) => {
    const success = await authService.register(firstName, lastName, phone, username, password, role, referredByCode, deviceFingerprint);
    if (success) {
      // Auto-login can be added here if desired
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const profile = await authService.getProfile();
      setUser(normalizeUser(profile));
    } catch (error) {
      console.error('Failed to refresh user profile:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
